import { Sprite } from 'pixi.js';
import { createBitmapText, scaleToFit } from '../../Utils/Utils';

export class BoosterPrice extends Sprite {
    constructor(width: number, height: number, price: number) {
        super();

        const bg = new Sprite(PIXI.utils.TextureCache['gameui/booster-cost-bg']); // names will change when we have final graphics
        bg.anchor.set(0.5, 0.5);
        bg.scale.set(scaleToFit(bg.width, bg.height, width, height));

        const txt = createBitmapText(
            price.toString(10),
            new PIXI.Rectangle(width * 0.1, height * 0.05, width * 0.4, height * 0.4),
            'riffic'
        );
        txt.anchor = 0.5;
        //@ts-ignore
        this.addChild(bg, txt);
    }
}
